const org_id = {
  type: 'autoInput',
  label: '部门',
  labelKey: 'org_name',
  placeholder: '请选择所属部门',
  rules: [
    {
      required: true,
      message: '请选择所属部门',
      trigger: 'change'
    }
  ],
  options: {
    placeholder: '输入部门关键词并选择',
    type: 'select', // input 还是select类型
    metholdKey: 'org', // 服务器请求接口key
    value: 'id',
    label: 'full_name',
    postData: ['org_id', 'sub_center_id'] // 需要回传表单的冗余数据
  }
};

const specialized_subject_id = {
  type: 'autoInput',
  label: '项目',
  labelKey: 'specialized_subject_full_name',
  rules: [
    {
      required: true,
      message: '请填写所属项目',
      trigger: 'change'
    }
  ],
  options: {
    placeholder: '输入项目关键词并选择',
    type: 'select', // input 还是select类型
    metholdKey: 'special', // 服务器请求接口key
    value: 'id',
    label: 'full_name',
    postData: ['specialized_subject_id', 'root_specialized_subject_id']
  }
};

const specialized_subject_id_parent = {
  type: 'autoInput',
  label: '项目大类',
  labelKey: 'specialized_subject_name',
  rules: [
    {
      required: true,
      message: '请填写所属项目大类',
      trigger: 'change'
    }
  ],
  options: {
    placeholder: '请输入项目关键词并选择',
    type: 'select', // input 还是select类型
    metholdKey: 'specialRoot', // 服务器请求接口key
    paramsKeys: ['org_id'],
    value: 'id',
    label: 'name'
  }
};

const specialized_subject_id_child = {
  type: 'autoInput',
  label: '项目',
  labelKey: 'specialized_subject_name',
  rules: [
    {
      required: true,
      message: '请填写所属子项目',
      trigger: 'change'
    }
  ],
  options: {
    placeholder: '请输入项目关键词并选择',
    type: 'select', // input 还是select类型
    metholdKey: 'specialByChild', // 服务器请求接口key
    paramsKeys: ['org_id', 'specialized_subject_id_parent'], // 服务器请求接口参数字段(级联查询需要)
    value: 'id',
    label: 'name'
  }
};

const building_id = {
  type: 'autoInput',
  label: '教学楼',
  labelKey: 'building_name',
  placeholder: '请选择教学楼',
  rules: [
    {
      required: true,
      message: '请选择教学楼',
      trigger: 'change'
    }
  ],
  options: {
    placeholder: '请输入教学楼关键词并选择',
    type: 'select', // input 还是select类型
    metholdKey: 'building', // 服务器请求接口key
    value: 'id',
    label: 'name'
  }
};

const fee_level_id = {
  type: 'autoInput',
  label: '项目级别',
  labelKey: 'specialized_subject_full_name',
  placeholder: '请填写项目级别',
  rules: [
    {
      required: true,
      message: '请填写项目级别',
      trigger: 'change'
    }
  ],
  options: {
    placeholder: '请输入关键词并选择',
    type: 'select', // input 还是select类型
    metholdKey: 'feeLevel', // 服务器请求接口key
    value: 'id',
    label: 'name'
  }
};

const teacher_ids = {
  type: 'autoInput',
  label: '任课老师',
  labelKey: 'teacher_names',
  placeholder: '请填写任课老师',
  rules: [
    {
      required: true,
      message: '请填写任课老师',
      trigger: 'blur'
    }
  ],
  options: {
    placeholder: '请输入关键词并选择',
    type: 'select', // input 还是select类型
    metholdKey: 'teacher', // 服务器请求接口key
    value: 'id',
    label: 'real_name',
    disabledKey: 'occupied',
    multiple: true,
    showOthers: ['id_card_no']
  }
};

const class_room_id = {
  type: 'autoInput',
  label: '教室',
  labelKey: 'class_room_name',
  placeholder: '请填写教室',
  rules: [
    {
      required: true,
      message: '请填写教室',
      trigger: 'change'
    }
  ],
  options: {
    placeholder: '请输入关键词并选择',
    type: 'select', // input 还是select类型
    metholdKey: 'classRoom', // 服务器请求接口key
    value: 'id',
    label: 'name',
    disabledKey: 'occupied'
  }
};
// 学员
const contact_id = {
  type: 'autoInput',
  label: '学员',
  labelKey: 'contact_name',
  placeholder: '学员姓名 / 证件号检索',
  rules: [
    {
      required: true,
      message: '请填写学员姓名',
      trigger: 'blur'
    }
  ],
  options: {
    placeholder: '学员姓名 / 证件号检索',
    type: 'select', // input 还是select类型
    metholdKey: 'contact', // 服务器请求接口key
    disabledKey: item => item.audit_status !== 2,
    showOthers: [
      'id_card_no',
      'phone',
      'nick_name',
      item => {
        const { id_card_no } = item;
        let birthday = '';
        if (!id_card_no) return '';
        if (id_card_no.length === 15) {
          birthday = `19${id_card_no.substr(6, 6)}`;
        } else if (id_card_no.length === 18) {
          birthday = id_card_no.substr(6, 8);
        } else {
          return '';
        }
        birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-');
        return new Date().getFullYear() - new Date(birthday).getFullYear() >= 18 ? '(成人)' : '(孩子)';
      },
      item => (item.audit_status === 2 ? '(已实名)' : '(未实名)')
    ], // 需要在下拉框展示的其他字段名
    value: 'id',
    label: 'name'
  }
};

const class_id = {
  type: 'autoInput',
  label: '班级名称',
  labelKey: 'class_name',
  placeholder: '请填写班级名称',
  rules: [
    {
      required: true,
      message: '请填写班级名称',
      trigger: 'change'
    }
  ],
  options: {
    placeholder: '请输入班级关键词并选择',
    type: 'select', // input 还是select类型
    metholdKey: 'class', // 服务器请求接口key
    value: 'id',
    label: 'name',
    paramsKeys: ['supply_time']
  }
};

// 班级普通查询
const class_id_query = {
  type: 'autoInput',
  label: '班级名称',
  labelKey: 'class_name',
  placeholder: '请填写班级名称',
  rules: [
    {
      required: true,
      message: '请填写班级名称',
      trigger: 'change'
    }
  ],
  options: {
    placeholder: '请输入班级关键词并选择',
    type: 'select', // input 还是select类型
    metholdKey: 'classIdQuery', // 服务器请求接口key
    value: 'id',
    label: 'name',
    itemSpan: 24,
    paramsKeys: ['year', 'term', 'org_id', 'specialized_subject_id']
  }
};

const class_id_org = {
  type: 'autoInput',
  label: '班级名称',
  labelKey: 'class_name',
  placeholder: '请填写班级名称',
  rules: [
    {
      required: true,
      message: '请填写班级名称',
      trigger: 'change'
    }
  ],
  options: {
    placeholder: '请输入班级关键词并选择',
    type: 'select', // input 还是select类型
    metholdKey: 'classQuery', // 服务器请求接口key
    value: 'id',
    label: 'name',
    paramsKeys: ['org_id', 'profession_id']
  }
};

const new_teacher_id = {
  type: 'autoInput',
  label: '代课老师',
  labelKey: 'new_teacher_name',
  placeholder: '请填写代课老师',
  rules: [
    {
      required: true,
      message: '请填写代课老师',
      trigger: 'blur'
    }
  ],
  options: {
    placeholder: '请输入老师名字并选择',
    type: 'select', // input 还是select类型
    metholdKey: 'classSupplyTeacherQuery', // 服务器请求接口key
    value: 'id',
    label: 'real_name',
    paramsKeys: ['supply_time'],
    disabledKey: 'occupied'
  }
};
const org_id_temp = window.cloneDeep(org_id);
const specialized_subject_id_parent_temp = window.cloneDeep(specialized_subject_id_parent);
const specialized_subject_id_child_temp = window.cloneDeep(specialized_subject_id_child);
const fee_level_id_temp = window.cloneDeep(fee_level_id);
org_id_temp.rules[0].required = false;
specialized_subject_id_parent_temp.rules[0].required = false;
specialized_subject_id_child_temp.rules[0].required = false;
fee_level_id_temp.rules[0].required = false;

org_id_temp.options.clearable = true;
specialized_subject_id_parent_temp.options.clearable = true;
specialized_subject_id_child_temp.options.clearable = true;

const specializedSearchForm = {
  org_id: org_id_temp,
  specialized_subject_id_parent: specialized_subject_id_parent_temp,
  specialized_subject_id: specialized_subject_id_child_temp,
  fee_level_id: {
    ...fee_level_id_temp,
    options: {
      ...fee_level_id.options,
      clearable: true,
      paramsKeys: ['org_id', 'specialized_subject_id']
    }
  }
};

const classSearchForm = {
  org_id: org_id_temp,
  specialized_subject_id_parent: specialized_subject_id_parent_temp,
  specialized_subject_id: specialized_subject_id_child_temp,
  fee_level_id: {
    ...fee_level_id_temp,
    options: {
      ...fee_level_id.options,
      clearable: true,
      paramsKeys: ['org_id', 'specialized_subject_id']
    }
  },
  class_room_id: {
    ...window.cloneDeep(class_room_id),
    options: {
      clearable: true,
      placeholder: '请输入关键词并选择',
      type: 'select', // input 还是select类型
      metholdKey: 'classRoom', // 服务器请求接口key
      value: 'id',
      label: 'name',
      disabledKey: 'occupied'
    },
    rules: []
  },
  building_id: {
    ...window.cloneDeep(building_id),
    options: {
      placeholder: '请输入教学楼关键词并选择',
      type: 'select', // input 还是select类型
      metholdKey: 'building', // 服务器请求接口key
      value: 'id',
      label: 'name',
      clearable: true
    },
    rules: []
  },
  teacher_id: {
    ...window.cloneDeep(teacher_ids),
    options: {
      clearable: true,
      placeholder: '请输入关键词并选择',
      type: 'select', // input 还是select类型
      metholdKey: 'teacher', // 服务器请求接口key
      value: 'id',
      label: 'real_name',
      disabledKey: 'occupied',
      multiple: false
    },
    rules: []
  },
  week_day: {
    type: 'select',
    label: '上课星期',
    placeholder: '全部星期',
    options: {
      clearable: true,
      select: [
        {
          label: '周日',
          value: '0'
        },
        {
          label: '周一',
          value: '1'
        },
        {
          label: '周二',
          value: '2'
        },
        {
          label: '周三',
          value: '3'
        },
        {
          label: '周四',
          value: '4'
        },
        {
          label: '周五',
          value: '5'
        },
        {
          label: '周六',
          value: '6'
        }
      ]
    }
  },
  age: {
    type: 'slot',
    label: '年龄限制'
  },
  class_date: {
    type: 'date',
    label: '上课时段',
    rules: [],
    options: {
      type: 'datetimerange',
      'range-separator': '至',
      'start-placeholder': '开始日期',
      'end-placeholder': '结束日期',
      'value-format': 'yyyy-MM-dd HH:mm:ss',
      itemSpan: 24
    }
  }
};

const insider_posts_id = {
  type: 'autoInput',
  labelKey: 'title',
  placeholder: '帖子检索',
  rules: [
    {
      required: true,
      message: '请输入帖子关键词检索',
      trigger: 'change'
    }
  ],
  options: {
    placeholder: '输入帖子关键词并选择',
    type: 'select', // input 还是select类型
    metholdKey: 'posts', // 服务器请求接口key
    value: 'id',
    label: 'content'
  }
};

const category_id = {
  type: 'autoInput',
  label: '板块',
  labelKey: 'category_name',
  placeholder: '板块名称检索',
  rules: [
    {
      required: true,
      message: '请输入板块名称检索',
      trigger: 'change'
    }
  ],
  options: {
    placeholder: '输入板块名称并选择',
    type: 'select', // input 还是select类型
    metholdKey: 'category', // 服务器请求接口key
    value: 'id',
    label: 'category_name'
  }
};

const news_category_id = {
  type: 'autoInput',
  label: '板块',
  labelKey: 'news_category_name',
  placeholder: '请选择类型名称',
  rules: [
    {
      required: true,
      message: '请选择类型名称',
      trigger: 'change'
    }
  ],
  options: {
    placeholder: '请选择类型名称',
    type: 'select', // input 还是select类型
    metholdKey: 'newsCategory', // 服务器请求接口key
    value: 'value',
    label: 'label',
    clearable: true
  }
};

export {
  news_category_id,
  classSearchForm,
  org_id,
  org_id_temp,
  specialized_subject_id,
  specialized_subject_id_parent,
  specialized_subject_id_child,
  specializedSearchForm,
  building_id,
  fee_level_id,
  teacher_ids,
  class_room_id,
  contact_id,
  class_id,
  new_teacher_id,
  class_id_org,
  class_id_query,
  insider_posts_id,
  category_id
};
